/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

export default function AnalyticsCard({

    title,
    subtitle,
    children

}) {

    return (

        <div className="
                bg-slate-50
                rounded-2xl
                border
                border-slate-200
                shadow-sm
                p-5
        ">

            <div className="mb-4">

                <h3 className="
                    text-lg
                    font-semibold
                    text-slate-900
                    mb-4
                ">
                    {title}
                </h3>

                {subtitle && (

                    <p className="
                        text-zinc-400
                        text-sm
                        mt-1
                    ">
                        {subtitle}
                    </p>

                )}

            </div>
                        <div
                className="
                    flex
                    justify-center
                    items-center
                    w-full
                "
            >
                {children}
                        </div>
        </div>

    );
}